import React from 'react';
import PropTypes from 'prop-types';
import AppIcon from '../../components/AppIcon';

const RightNavButton = props => (
  <div className={props.className} onClick={props.onClick}>
    <AppIcon iconName="ARROW_DOWN" containerClass="arrow-icon" />
  </div>
);

RightNavButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};

RightNavButton.defaultProps = {
  className: '',
  onClick: () => {}
};

export default RightNavButton;



// WEBPACK FOOTER //
// ./src/containers/TimeSlots/RightNavButton.jsx